export default "__VITE_ASSET__DMwUFDqK__"